<template>
  <table
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(17, 39, 72, 0.8)"
    :class="['table', currentTab != 'alarm' ? 'table-fixed' : '']"
    style="text-align: left; width: 100%"
  >
    <thead
      style="display: block;width: 100%;white-space: nowrap; background:rgba(2,51,107,1);position: sticky;top: 0;z-index: 99;"
    >
      <tr style="display: block;">
        <th
          v-for="(c, idx) in options"
          :key="c.value"
          style="height: 4.37vh; font-weight: 400"
          :style="{ width: c.width, padding: idx == 2 ? '0 8px 0 0' : '0' }"
        >
          <div
            :style="{
              width: c.width,
              textAlign: 'center',
              height: c.unit && '1.67vh',
              lineHeight: '1.67vh',
              textAlign: 'center',
              position: 'relative'
            }"
          >
            <div style="text-align: center; font-size: 1.48vh">
              {{ c.label }}
            </div>
            <div
              v-if="isShowSortArrow(c.value)"
              style="width: 0.52vw; height: 0.11vh; position: absolute; top: 0; right: 0.5vw;"
            >
              <i
                class="rz_iconfont icon-zhengxv"
                :style="{
                  color:
                    sortOption.type == c.value && sortOption.order == 'asc'
                      ? '#63EBC7FF'
                      : '#FFDFDFDF'
                }"
                style="position: absolute; top: 0; cursor: pointer"
                @click="sortByType(c.value, 'asc')"
              ></i>
              <i
                class="rz_iconfont icon-daoxv"
                :style="{
                  color:
                    sortOption.type == c.value && sortOption.order == 'des'
                      ? '#63EBC7FF'
                      : '#FFDFDFDF'
                }"
                style="position: absolute; top: 0.73vh; cursor: pointer"
                @click="sortByType(c.value, 'des')"
              ></i>
            </div>
          </div>
          <div
            v-if="c.unit"
            :style="{
              width: c.width,
              fontSize: '1.11vh',
              textAlign: 'center',
              height: '1.30vh',
              lineHeight: '1.30vh'
            }"
          >
            ({{ c.unit }})
          </div>
        </th>
      </tr>
    </thead>
    <tbody
      v-if="tableData && tableData.length > 0"
      style="display: block;width: 100%;"
    >
      <tr
        v-if="!page_config.showWind && currentTab != 'alarm'"
        style="display: block; background: #0b1f42; height: 5.2vh"
      >
        <td class="xianzhi" style="width: 1.56vw;padding: 0"></td>
        <td class="xianzhi" style="width: 8.85vw;min-width: 8.85vw;padding: 0">
          V类标准限值
        </td>
        <td class="xianzhi" style="width: 4.69vw;padding: 0 8px 0 0"></td>
        <td
          class="xianzhi"
          style="width: 4.69vw"
          v-for="x in options.slice(3)"
          :key="x.value"
        >
          <span v-show="x.value === 'cod'"> 40 </span>
          <span v-show="x.value === 'ammonia_nitrogen'"> 2.0 </span>
          <span v-show="x.value === 'dissolved_oxygen'"> 2 </span>
        </td>
      </tr>
      <tr
        v-for="(s, idx) in tableData"
        :key="s.id"
        style="display: block;"
        :style="{ background: curId == s.id ? '#012546' : '' }"
      >
        <td
          v-for="(c, index) in options"
          :key="c.value"
          :style="{ width: c.width, padding: index == 2 ? '0 8px 0 0' : '0' }"
        >
          <div v-if="c.value == 'index'" :style="{ width: c.width }">
            <span
              style="display: block; width: 1.2vw; height: 1.48vh; font-size: 1.48vh; line-height: 0.83vw; text-align: center; border-radius:2px; background-color: #00499A; margin: 0 auto"
              >{{ idx + 1 }}</span
            >
          </div>
          <div
            v-else-if="c.link"
            :style="{
              width: c.width,
              color: curId == s.id ? 'red' : '#2CF0F1'
            }"
            style="color: #00FFFF;cursor: pointer; text-align: center; font-size: 1.48vh;"
            @click="c.value == 'name' ? openMapWindow(s) : locateAlarm(s)"
          >
            {{ s[c.value] | lengthLimit(c.limit) }}
            <i
              class="iconfont icon-shipin"
              style="color:orange"
              v-show="s.camera_online"
            ></i>
          </div>
          <!-- color: getPMInfo(s[c.value], c.value).bgcolor, -->
          <div v-else-if="c.value == 'category'" :style="{ width: c.width }">
            <span
              v-for="(x, idx) in [getWaterType(s)]"
              :key="idx"
              :style="{ background: x.bgcolor }"
              class="category-bg"
            >
              {{ x.name }}
            </span>
          </div>
          <div
            v-else-if="c.round"
            style="height:100%; text-align: center;font-weight: 400; font-size: 1.48vh; "
            :style="{ width: c.width }"
          >
            <span
              :style="{
                background:
                  getWaterType(s).name == '劣V' &&
                  getWaterType(s).worst_sensortype_list.includes(c.value)
                    ? getWaterType(s).bgcolor
                    : ''
              }"
              :class="
                getWaterType(s).name == '劣V' &&
                getWaterType(s).worst_sensortype_list.includes(c.value)
                  ? 'category-bg'
                  : ''
              "
            >
              {{ $sensortypeRound(s[c.roundKey] || c.value, s[c.value]) }}
            </span>
          </div>
          <div
            v-else
            :class="c.value == 'station_name' ? 'ellipsis-class' : ''"
            :style="{ width: c.width, textAlign: 'center', fontSize: '1.48vh' }"
          >
            {{ s[c.value] | lengthLimit(c.limit) }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { data_filter, lengthLimit } from "@/utils/filters";
import { ValRound } from "@/utils/commonUtils";
import _ from "lodash";
export default {
  props: {
    tableStyle: Object,
    data: Array,
    options: Array,
    loading: {
      type: Boolean,
      default: false
    },
    currentTab: String
  },
  data() {
    return {
      sortOption: {
        type: "pm10",
        order: "des"
      },
      curId: ""
    };
  },
  filters: {
    data_filter,
    lengthLimit
  },
  computed: {
    ...mapState(["mapMode", "page_config"]),
    ...mapGetters(["intensity"]),
    trBg() {
      if (this.$theme == "light") {
        return "#e6e6e6";
      } else {
        return "#081f4b";
      }
    },
    tableData() {
      let data = _.cloneDeep(this.data);
      if (!data) {
        return;
      }
      // 将无数据的放到后面 对有数的数据进行排序
      const { type, order } = this.sortOption;
      let noValData = data.filter(item => item[type] == "--");
      let hasValData = data.filter(item => item[type] != "--");
      if (type && order) {
        // 排序：微站数据按数值排序，报警记录按时间排序
        if (order === "des") {
          type !== "update_time"
            ? hasValData.sort((a, b) => b[type] - a[type])
            : hasValData.sort(
                (a, b) => Date.parse(b[type]) - Date.parse(a[type])
              );
        } else {
          type !== "update_time"
            ? hasValData.sort((a, b) => a[type] - b[type])
            : hasValData.sort(
                (a, b) => Date.parse(a[type]) - Date.parse(b[type])
              );
        }
      }
      data = hasValData.concat(noValData);
      return data;
    }
  },
  watch: {
    tableStyle: {
      handler() {
        console.log(this.tableStyle);
      },
      immdiate: true
    },
    currentTab() {
      // 切换tab排序，保留用户的选择的排序
      if (this.currentTab == "alarm") {
        if (this.alarmSortOption) {
          this.sortOption = this.alarmSortOption;
        } else {
          this.sortOption = { type: "end_time", order: "des" };
        }
      }
      if (this.currentTab === "real") {
        if (this.realSortOption) {
          this.sortOption = this.realSortOption;
        } else {
          this.sortOption = { type: "pm10", order: "des" };
        }
      }
    },
    mapMode() {
      // 退出报警 清除数据和选中状态
      if (this.mapMode != "alarm") {
        this.curId = "";
        this.$store.commit("updateLocateAlarm", null);
      }
    }
  },
  methods: {
    ValRound,
    // getPMInfo,
    getWaterType(item) {
      if (!_page_config.sensortypes.length) {
        return {};
      }
      let sensortypeArr = [];
      const check_sensor_types = [
        "cod",
        "ammonia_nitrogen",
        "ph",
        "dissolved_oxygen"
      ];
      _page_config.sensortypes.forEach(x => {
        if (check_sensor_types.includes(x.value)) {
          sensortypeArr.push({ name: x.value, value: item[x.value] });
        }
      });
      return colorIntensity.getWaterQualityCategory(sensortypeArr, "static");
    },
    openMapWindow(s) {
      this.$store.commit("openMapWindow", s);
    },
    locateAlarm(s) {
      this.curId = s.id;
      s.origin = "alarmRecord";
      this.$store.commit("updateMapMode", "alarm");
      this.$store.commit("updateLocateAlarm", s);
    },
    sortByType(type, order) {
      const option = { type, order };
      this.sortOption = option;

      // 记录用户切换tab前的排序依据
      if (this.currentTab == "alarm") {
        this.alarmSortOption = option;
      } else {
        this.realSortOption = option;
      }
    },
    isShowSortArrow(v) {
      return (
        v != "index" &&
        v != "name" &&
        v != "wind_direction" &&
        v != "start_time" &&
        v != "station_name" &&
        v != "type_name" &&
        v != "category"
      );
    }
  }
};
</script>

<style lang="less">
.table {
  th {
    // padding: 0.068vh 0.4vw;
  }
  tbody {
    tr {
      height: 6.2vh;
      border-bottom: 1px solid rgba(17, 38, 67, 1);
      td {
        height: 6.2vh;
        line-height: 6.2vh;
      }
      .xianzhi {
        height: 5.2vh;
        line-height: 5.2vh;
        font-size: 1.48vh;
        text-align: center;
      }
    }
  }
  tr:nth-child(1) {
    td {
      height: 6.2vh;
      line-height: 1.75;
    }
    td:nth-child(5) {
      line-height: 6.2vh;
    }
  }

  td {
    font-size: 1.818vh;
  }
}

tbody::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0.3vw; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
tbody::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
tbody::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: grey;
}

div::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0.3vw; /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}
div::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
div::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: grey;
}
</style>
<style lang="less" scoped>
.category-bg {
  display: inline-block;
  text-align: center;
  border-radius: 5px;
  padding: 4px 0;
  width: 3vw;
  color: #000;
  font-size: 1.48vh;
  line-height: normal;
}
.table-fixed {
  th:nth-child(1) {
    position: sticky;
    left: 0;
    z-index: 10;
    background: rgba(2, 51, 107, 1);
  }
  td:nth-child(1) {
    position: sticky;
    left: 0;
    z-index: 10;
    background-color: #0b1a2f;
  }
  th:nth-child(2) {
    position: sticky;
    left: 1.56vw;
    z-index: 10;
    background: rgba(2, 51, 107, 1);
  }
  td:nth-child(2) {
    position: sticky;
    left: 1.56vw;
    z-index: 10;
    background-color: #0b1a2f;
  }
  th:nth-child(3) {
    position: sticky;
    left: 10.41vw;
    z-index: 10;
    background: rgba(2, 51, 107, 1);
  }
  td:nth-child(3) {
    position: sticky;
    left: 10.41vw;
    z-index: 10;
    background-color: #0b1a2f;
  }
  tbody > tr:first-child > td:nth-child(-n + 3) {
    background: #0b1f42;
  }
}
.ellipsis-class {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
